import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'lib-flexible/flexible';
import Vant from 'vant';
import 'vant/lib/index.css';
import '@/styles/index.scss';
import validate from '@/utils/validate';
import utils from '@/utils';
import customComponents from '@/components';
import vconsole from '@/utils/vconsole';
import logger from '@/utils/logger';
import { registerWxWorkOAuthRedirect } from '@/utils/wxCommon';

registerWxWorkOAuthRedirect();
Vue.prototype.$utils = utils;
Vue.prototype.$validate = validate;
Vue.use(Vant);
Vue.use(customComponents);

Vue.config.productionTip = false;
const meta = document.createElement('meta');
const head = document.getElementsByTagName('head');
if (process.env.VUE_APP_ENV === 'prod') {
  meta.content = 'upgrade-insecure-requests';
  meta.httpEquiv = 'Content-Security-Policy';
}
else {
  meta.content = 'IE=edge';
  meta.httpEquiv = 'X-UA-Compatible';
}
console.log(head, 'headheadheadheadhead');
head[0].appendChild(meta);
if (process.env.VUE_APP_ENV !== 'prod') {
  // 非生产环境打开vue调试工具
  Vue.config.devtools = true;
}

new Vue({
  router,
  store,
  vconsole,
  logger,
  render: h => h(App),
}).$mount('#app');
